module.exports = __webpack_public_path__ + "static/img/shouchi.d5e4f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/survery/shouchi.png
// module id = gU/a
// module chunks = 1